import { FC, useMemo } from "react";
import styles from "./StockShortsDailyInterestChart.module.scss";
import { useAtomValue } from "jotai";
import { formatDate, nFormatter } from "@/lib/utils";
import { positiveState } from "@/lib/store";
import dayjs from "dayjs";
import TimeSeriesChart, { type TimeSeries } from "@/components/ortex-charts/TimeSeriesChart";

interface PropsTypes {
    data: Array<number>;
    reflow?: boolean;
    obfuscated?: boolean;
}

/** A believable curve for the obfuscated (locked) state, so the blur has something under it. */
const placeholder = (count: number, randomizer: number): [number, number][] => {
    const out: [number, number][] = [];
    for (let i = 0; i < count; i++) out.push([Date.now() - (count - 1 - i) * 86_400_000, i ** 2 + Math.random() * randomizer]);
    return out;
};

const StockShortsDailyInterestChart: FC<PropsTypes> = ({ data, obfuscated }) => {
    const positive = useAtomValue(positiveState);
    const series = useMemo<TimeSeries[]>(
        () => [{ id: "value", title: "Value", type: "line", data: obfuscated ? placeholder(25, 100) : ((data as unknown as [number, number][]) ?? []), color: positive, precision: 2, formatter: (v) => nFormatter(v, 2), legend: false }],
        [data, obfuscated, positive]
    );

    return (
        <div className={styles.StockShortsDailyInterestChart}>
            <TimeSeriesChart series={series} timeAxis={false} grid={false} legend={false} rangeButtons={false} exportMenu={false} axes={[{ id: "right", visible: false }]} obfuscated={obfuscated} tooltipTitle={(t) => formatDate(dayjs.utc(t))} />
        </div>
    );
};

export default StockShortsDailyInterestChart;
